import { lazy } from 'react';

// Lazy load page components for better code splitting
export const HomePage = lazy(() => import('../pages/HomePage/HomePage'));

export const ConversationLayout = lazy(
  () => import('../pages/ConversationLayout/ConversationLayout'),
);

export const NewConversationPage = lazy(
  () => import('../pages/NewConversationPage/NewConversationPage'),
);

export const ConversationPage = lazy(
  () => import('../pages/ConversationPage/ConversationPage'),
);

export const DoctorConversations = lazy(
  () => import('../pages/DoctorConversations/DoctorConversations'),
);
